import styled from "styled-components";

export const TabContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: 100%;
    overflow: hidden;
    padding-top: 10px;

    #tableContScroll {
        display: flex;
        flex-direction: column;
        min-height: 0;
        max-height: 100%;

        > .MuiTableContainer-root {
            flex: 1;
            min-height: 0;
            overflow: auto;

            .MuiTableHead-root {
                tr:first-child {
                    display: none;
                }

                tr:last-child .MuiTableCell-root {
                    top: 0 !important;
                }
            }
        }
    }
`;
